import React from "react";
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { makeStyles } from "@material-ui/core/styles";
import Age from '../../Helpers/Dates/Age';
import States from '../../Helpers/Lists/States';
import ConvertToShortHandHeight from '../../Helpers/Formatters/ShortHandHeight';
import TobaccoUsage from "./Helpers/TobaccoUsage";
import SvgIcon from '@material-ui/core/SvgIcon';
import PinLocationIcon from '../../../icons/pin-location.svg';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import NoSmokeIcon from '../../../icons/no-smoke.svg';
import HeightIcon from '../../../icons/height.svg';

import "./QuoteBasicInfo.scss";

const useStyles = makeStyles(theme => ({
    cardTitle: {
        color: theme.palette.primary.main,
        fontWeight: 700,
        fontSize: "12px",
        margin: "5px 0 0 0",
    },
    lightBackground: {
        backgroundColor: `${theme.palette.primary.main}16`,
    },
}));

export default function QuoteBasicInfo(props) {
    
    const classes = useStyles();
    return (
        <div className="quote bg-white">
            <Row className="text-center">
                <Col className="line d-flex flex-column align-items-center">
                <div className={`icon-container ${classes.lightBackground}`}>
                    <SvgIcon component={PinLocationIcon} color='primary' />
                </div>
                <p className={classes.cardTitle}>Getting Options for</p>
                <div className='mt-1'>
                    { States().map(s => s.value === props.basicInfo.state ? s.label : "") }
                    </div>
                </Col>
                <Col className="line d-flex flex-column align-items-center">
                <div className={`icon-container ${classes.lightBackground}`}>
                    <SvgIcon component={PermIdentityIcon} color='primary' />
                </div>
                <p className={classes.cardTitle}>Calculating rates for</p>
                <div className='mt-1'>
                    {props.basicInfo.gender == 'F' ? 'Female' : 'Male'}</div>
                <div className="mt-1">{Age(props.basicInfo.birthdate)} Years Old</div>
                </Col>
                <Col className="line d-flex flex-column align-items-center">
                <div className={`icon-container ${classes.lightBackground}`}>
                    <SvgIcon component={HeightIcon} color='primary' />
                </div>
                <p className={classes.cardTitle}>Height &amp; Weight</p>
                <div className='mt-1'> {props.basicInfo.height != null ? ConvertToShortHandHeight(props.basicInfo.height) : ""}</div>
                <div className="mt-1"> {props.basicInfo.weight != null ? props.basicInfo.weight.replace(" pounds","lbs") : ""}</div>
                </Col>
                <Col className="d-flex flex-column align-items-center">
                <div className={`icon-container ${classes.lightBackground}`}>
                    <SvgIcon component={NoSmokeIcon} color='primary' />
                </div>
                <p className={classes.cardTitle}>Tobacco Modifier</p>
                <div className='mt-1'>{TobaccoUsage(props.basicInfo.tobacco) == 'true' ? 'Consumed Tobacco' : 'No Tobacco'}</div>
                </Col>
            </Row>
        </div>
    )
}

QuoteBasicInfo.propTypes = {
    basicInfo: PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/QuoteBasicInfo.js